import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const EmotionalSupplementPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/EmotionalHeader.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Child Emotional Quotient - Part 2</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell50NBLeft}>
                    <Text style={reportStyles.PageSubTitle}>Psychosomatic</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Child Reported</Text>
                    <Text style={reportStyles.description}>Favourability Ratio:</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedGreenEQDonut.png'} style={reportStyles.image186Cell}/> 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Parent Reported</Text>
                    <Text style={reportStyles.description}>Favourability Ratio:</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/RedMoreGreenDonut.png'} style={reportStyles.image186Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/RedBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Not Reported</Text>
                </View>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/RedBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Unfavorable</Text>
                </View>
                <View style={reportStyles.cell33BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenBox.png'} style={reportStyles.image22Cell}/> 
                    <Text style={reportStyles.description}>Favorable</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50NBLeft}>
                    <Text style={reportStyles.PageSubTitle}>Urgent Concerns</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Child Reported</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenFlag.png'} style={reportStyles.image186Cell}/> 
                    <Text style={reportStyles.description}>Detected</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenCross.png'} style={reportStyles.image22Cell}/> 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Parent Reported</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenFlag.png'} style={reportStyles.image186Cell}/> 
                    <Text style={reportStyles.description}>Detected</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenCross.png'} style={reportStyles.image22Cell}/> 
                </View>
            </View>
        </View>                                   
       </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Child Psychologist within a short period of time
could be useful in improving the physical wellbeing of the child. This is calculated based on the
answers received in the scan and peer comparisons.

            Factor score indicates the number of factors that have contributed to the recommendation of a consultation. Need one-line description from Dr. Roma.
        </Text>
    </View>                            
    </Page>                      


)          
}
  
export default EmotionalSupplementPage